import { CheckIcon } from 'components/icons'
import { FC } from 'react'

type SelectedCheckmarkProps = {
  selected: boolean
  active: boolean
}
export const SelectedCheckmark: FC<SelectedCheckmarkProps> = ({
  selected,
  active,
}) => {
  if (!selected) {
    return null
  }

  return (
    <span
      className={`${active ? 'text-info' : 'text-info'}
absolute inset-y-0 left-0 flex items-center pl-3`}>
      <CheckIcon className="h-5 w-5" aria-hidden="true" />
    </span>
  )
}
